/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const SupportEnum = {
    GET_SUPPORT_STATUS: '/support/status',
    GET_DOWNLOAD: (type: string): string => {
        return '/support/download/' + type;
    }
};
